<template>
  <div class="team-member" :class="teamMemberStatusMap[generalStatus]">
    <template v-if="!member.Ephemeral.editing">
      <div class="person" v-if="subsModel == 'onhb'">
        <div class="fa" v-if="generalStatus!='status-cancelled'">
          <font-awesome-icon v-if="member.NewSuiUser.user_status == 'validated'" icon="check" />
          <font-awesome-icon v-if="member.NewSuiUser.user_status == 'invited' || member.NewSuiUser.user_status == 'new'" icon="clock" />
        </div>
        {{ member.NewSuiUser.name }} {{ member.NewSuiUser.surname }} (&#8203;
        <a
          class="generic-link"
          :href="`mailto:${member.NewSuiUser.email}`"
        >
          {{
          member.NewSuiUser.email
          }}
        </a>&#8203;)&#8203;
        <template v-if="role == 'membro'">, {{ printGrade }}</template>
        <template v-if="member.NewSuiUser.gender == 'f'">, gênero feminino</template>
        <template v-if="member.NewSuiUser.gender == 'm'">, gênero masculino</template>
        <template v-if="member.NewSuiUser.gender == 'outro'">, gênero outro</template>
        <template v-if="member.NewSuiUser.gender == 'nao_respondeu'">, preferiu não informar o gênero</template>
        <div style="margin-top:10px; line-height:18px;" v-if="exemptionElligibility && member.SuiUserEdit.email && member.NewSuiUser.exemption == 'true' && !member.NewSuiUser.exemptionApproved">
          <em><small>Pedido de isenção registrado. Ele será avaliado até 05/04/2025.</small></em>
        </div>
        <div style="margin-top:10px; line-height:18px;" class="grade-selection" v-if="exemptionElligibility && member.SuiUserEdit.email && member.NewSuiUser.exemptionApproved == 'false'">
          <em><small>O pedido de isenção foi recusado em 05/04/2025, motivo: "{{ member.NewSuiUser.approvalReasoning }}"</small></em>
        </div>
        <div style="margin-top:10px; line-height:18px;" v-if="exemptionElligibility && member.SuiUserEdit.email && member.NewSuiUser.exemptionApproved == 'true'">
          <em><small>Pedido de isenção foi aceito em 05/04/2025. Clique em "Atualizar cobrança" para gerar um boleto com o valor atualizado. Observação: no caso de 3 alunos isentos na equipe existe um pagamento simbólico de R$ 5,00.</small></em>
        </div>
      </div>
      <div class="person" v-else>
        <div class="fa" v-if="generalStatus!='status-cancelled'">
          <font-awesome-icon v-if="member.NewSuiUser.user_status == 'validated'" icon="check" />
          <font-awesome-icon v-if="member.NewSuiUser.user_status == 'invited' || member.NewSuiUser.user_status == 'new'" icon="clock" />
        </div>
        {{ member.NewSuiUser.name }} {{ member.NewSuiUser.surname }}.
        <a
          class="generic-link"
          :href="`mailto:${member.NewSuiUser.email}`"
          v-if="modality=='pre_zapzap'"
        >
          (&#8203;{{
          member.NewSuiUser.email
          }}&#8203;)&#8203;
        </a>
        <em v-if="member.NewSuiUser.auxId">Dados adicionais preenchidos.</em>
      </div>
    </template>
    <template v-if="member.Ephemeral.editing">
      <div class="uninvited-member extra-small-fields" v-if="generalStatus!='status-cancelled'" :class="{'extended-fields': subsModel != 'onhb'}">
        <div class="email-input" v-if="subsModel == 'onhb' || modality != 'pre_residencia' ">
          <label class="generic-label" :for="`email-${teamId}-${member.NewSuiUser.id}`" >Email</label>
          <input type="email" class="generic-input"
                 :id="`email-${teamId}-${member.NewSuiUser.id}`"
                 :value="member.SuiUserEdit.email"
                 @input="changeFieldData('email',$event.target.value)"
                 :disabled="amILoading || !canEdit"/>
        </div>
        <div class="name-input">
          <label class="generic-label" :for="`name-${teamId}-${member.NewSuiUser.id}`">Nome</label>
          <input type="text" class="generic-input"
                 :id="`name-${teamId}-${member.NewSuiUser.id}`"
                 :value="member.SuiUserEdit.name"
                 @input="changeFieldData('name',$event.target.value)"
                 :disabled="amILoading || !canEdit"/>
        </div>
        <div class="surname-input">
          <label class="generic-label" :for="`surname-${teamId}-${member.NewSuiUser.id}`">Sobrenome</label>
          <input type="text" class="generic-input"
                 :id="`surname-${teamId}-${member.NewSuiUser.id}`"
                 :value="member.SuiUserEdit.surname"
                 @input="changeFieldData('surname',$event.target.value)"
                 :disabled="amILoading || !canEdit"/>
        </div>
        <div class="grade-selection" v-if="index>1 && subsModel == 'onhb'">
          <label class="generic-label" :for="`grade-${teamId}-${member.NewSuiUser.id}`">Série</label>
          <select class="generic-select"
                  :id="`grade-${teamId}-${member.NewSuiUser.id}`"
                  :value="member.SuiUserEdit.sui_grade_id"
                  @input="changeFieldData('sui_grade_id',$event.target.value)"
                  :disabled="amILoading || (!canEdit && !editOwnData)">
            <option disabled selected>---</option>
            <option v-for="(grade, i) in grades" :key="`grade-${teamId}-${member.NewSuiUser.id}-${i}`" v-bind:value="grade.id">
              {{
              grade.label
              }}
            </option>
          </select>
        </div>

        <div class="gender-selection" v-if="index>1 && subsModel == 'onhb'">
          <label class="generic-label" :for="`gender-${teamId}-${member.NewSuiUser.id}`">Gênero *</label>
          <select class="generic-select" :id="`gender-${teamId}-${member.NewSuiUser.id}`"
                  :disabled="amILoading || (!canEdit && !editOwnData)"
                  :value="member.SuiUserEdit.gender"
                  @input="changeFieldData('gender',$event.target.value)">
            <option disabled selected>---</option>
            <option :key="`gender-${teamId}-${member.NewSuiUser.id}-0`" value="f">feminino</option>
            <option :key="`gender-${teamId}-${member.NewSuiUser.id}-1`" value="m">masculino</option>
            <option :key="`gender-${teamId}-${member.NewSuiUser.id}-2`" value="outro">outro</option>
            <option :key="`gender-${teamId}-${member.NewSuiUser.id}-3`" value="nao_respondeu">prefiro não informar</option>
          </select>
        </div>


        <div class="grade-selection" v-if="index<=1 && subsModel == 'onhb'">
          <label class="generic-label" :for="`grade-${teamId}-${member.NewSuiUser.id}`">Prof. Matemática?</label>
          <select class="generic-select" :id="`grade-${teamId}-${member.NewSuiUser.id}`"
                  :value="member.SuiUserEdit.professor_type || 'S'"
                  @input="changeFieldData('professor_type',$event.target.value)"
                  :disabled="amILoading || !canEdit">
            <option disabled selected>---</option>
            <option :key="`grade-${teamId}-${member.NewSuiUser.id}-sim`" value="S">Sim</option>
            <option :key="`grade-${teamId}-${member.NewSuiUser.id}-nao`" value="N">Não</option>
          </select>
        </div>

        <div class="grade-selection" v-if="index>1 && subsModel == 'onhb' && exemptionRequest && (typeof member.NewSuiUser.exemptionApproved === 'undefined') && exemptionElligibility && member.SuiUserEdit.email">
          <label class="generic-label" :for="`exemption-${teamId}-${member.NewSuiUser.id}`">Pedido de isenção?</label>
          <select class="generic-select"
                  :id="`exemption-${teamId}-${member.NewSuiUser.id}`"
                  :value="member.SuiUserEdit.exemption"
                  @input="changeFieldData('exemption',$event.target.value)"
                  :disabled="amILoading">
            <option disabled selected>---</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
          <div style="display:none;">{{member}}</div>
        </div>

        <div class="grade-selection" v-if="index>1 && subsModel == 'onhb' && exemptionRequest && exemptionElligibility  && member.SuiUserEdit.email && member.SuiUserEdit.exemption == 'true'">
          <label class="generic-label" :for="`exemption-stamp-${teamId}-${member.NewSuiUser.id}`">Família do(a) estudante recebe auxílio governamental?</label>
          <select class="generic-select" :id="`exemption-stamp-${teamId}-${member.NewSuiUser.id}`" :value="member.SuiUserEdit.exemptionStamp" @input="changeFieldData('exemptionStamp',$event.target.value)" :disabled="amILoading">
            <option disabled selected>---</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>

        <div class="grade-selection" v-if="index>1 && subsModel == 'onhb' && exemptionRequest && exemptionElligibility   && member.SuiUserEdit.email && member.SuiUserEdit.exemptionStamp == 'true' && member.SuiUserEdit.exemption == 'true'">
<!--          https://docs.google.com/forms/d/e/1FAIpQLSe8AmalcqW0q3XEZcufHoqRUz5FBzTIdtzKi7my3Qsmf7wFvA/viewform?usp=pp_url&entry.123891520=edr32r23-->
          <p style="font-size: 12px">Antes de convidar o estudante faça <strong>o upload dos comprovantes <a :href="`https://tally.so/r/w5poGv?id=${member.NewSuiUser.id}`" target="_blank">neste formulário</a></strong> </p>
        </div>

        <div class="grade-selection" v-if="index>1 && subsModel == 'onhb' && exemptionRequest && exemptionElligibility  && member.SuiUserEdit.email && member.SuiUserEdit.exemptionStamp == 'true' && member.SuiUserEdit.exemption == 'true'">
          <label class="generic-label" :for="`exemption-proof-${teamId}-${member.NewSuiUser.id}`">Já fez o upload da documentação comprobatória?</label>
          <select class="generic-select" :id="`exemption-proof-${teamId}-${member.NewSuiUser.id}`" :value="member.SuiUserEdit.exemptionProof" @input="changeFieldData('exemptionProof',$event.target.value)" :disabled="amILoading">
            <option disabled selected>---</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>

      </div>
    </template>

    <div class="actions">
      <template v-if="generalStatus!='status-cancelled' && (canEdit || editOwnData)">
        <template v-if="member.Ephemeral.editing">
          <button v-if="subsModel == 'onhb' || (modality == 'pre_zapzap' && index != 1)" class="btn-action faded extra-small" @click="inviteMember({teamId,index: (index-1)})" :class="{'btn-loading': amILoading}"  :disabled="amILoading || !teamSubsStillGoing">
            {{ member.NewSuiUser.name === '' ? "Convidar" : "Salvar" }}
          </button>
          <button v-else class="btn-action faded extra-small" @click="editMemberInfo({teamId,index: (index-1)})" :class="{'btn-loading': amILoading}"  :disabled="amILoading || !subsStillGoing">
            {{index == 1 ? "Enviar"  : "Adicionar"}}
          </button>
          <button v-if="(subsModel == 'onhb'  & member.NewSuiUser.user_status !== 'unsaved') || (subsModel != 'onhb' && member.NewSuiUser.auxId)" class="btn-action faded extra-small" @click="cancelEdit(index-1)" :class="{'btn-loading': amILoading}" :disabled="amILoading || !teamSubsStillGoing">
            Cancelar
          </button>
        </template>
        <template v-if="!member.Ephemeral.editing">
<!--       @todo: make "remover" for pre_onhb   -->
          <button v-if="subsModel == 'onhb'"
                  class="btn-action faded extra-small"
                  @click="removeMember({teamId,index: (index-1)})"
                  :class="{'btn-loading': amILoading}"
                  :disabled="amILoading || (!canEdit) || !teamSubsStillGoing"
                  :style="(!canEdit || status === 'completed') ? 'visibility:hidden':''">Remover</button>
          <button class="btn-action faded extra-small"
                  @click="openEditForm" :class="{'btn-loading': amILoading}"
                  :disabled="amILoading || !teamSubsStillGoing">Editar</button>
        </template>
      </template>
    </div>

    <div class="warnings">
      <template v-if="member.Ephemeral.editing && (canEdit || editOwnData)">
        <div class="gender-selection" v-if="index>1 && subsModel == 'onhb'">
          <p style="font-size: 10px">* Esta informação será utilizada para a definição de isenção, classificação e premiações, incluindo a da cerimônia presencial, envolvendo meninas.
          </p>
        </div>
      </template>
    </div>

    <div class="team-status">
      <p v-if="generalStatus!='status-cancelled'">{{ printRole }}>>> {{ printStatus }}</p>
      <p v-else>{{printRole}}</p>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import professions from "../../lib/professions";
import states from "../../lib/states";
import countries from "../../lib/countries";
import cities from "../../lib/cities";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "TeamMemberDef",
  data() {
    let ages = [];
    let i;

    for (i = 12; i < 140; i++) {
      ages.push(i);
    }

    return {
      gradesold: ["8º/Fund.", "9º/Fund.", "1º/Médio", "2º/Médio", "3º/Médio"],
      grades: [
        {id:  6, label: "6º/Fund. (nível ALFA)"},
        {id:  7, label: "7º/Fund. (nível ALFA)"},
        {id:  8, label: "8º/Fund. (nível ALFA)"},
        {id:  9, label: "9º/Fund. (nível ALFA)"},
        {id: 10, label: "1º/Médio (nível BETA)"},
        {id: 11, label: "2º/Médio (nível BETA)"},
        {id: 12, label: "3º/Médio (nível BETA)"}
      ],
      ages: ages,
      teamMemberStatusMap: {
        "invited": "invited",
        "new": "invited",
        "unsaved": "vacant",
        "validated": "confirmed",
        "status-cancelled": "status-cancelled"
      },
      professions
    };
  },
  props: ["member", "role", "index", "status", "canEdit", "teamId", "editOwnData","subsModel", 'modality','exemptionElligibility', 'exemptionRequest'],
  computed: {
    ...mapGetters(["amILoading", "subsStillGoing", "teamSubsStillGoing"]),
    generalStatus: function() {
      //AQUIAQUI

      // if (this.member.NewSuiUser.name == 'VERDURA') {
      //   return 'asdasd';
      // }

      if (this.subsModel == 'onhb' || (this.index > 1 && this.modality == 'pre_zapzap')) {
        if (this.status != "user_cancelled") {
          return this.member.NewSuiUser.user_status;
        } else {
          return "status-cancelled";
        }
      }
      else {
        if (typeof (this.member.NewSuiUser.auxId) == 'undefined') {
          return "unsaved";
        } else {
          return "validated";
        }
      }
    },
    printGrade: function () {
      let sui_grade_id = this.member.NewSuiUser.sui_grade_id;
      return this.grades.reduce(function (acc, item) {
        if (item.id == sui_grade_id) {
          return item.label;
        }
        return acc;
      }, "")
    },
    printStatus: function() {
      let translation = {
        validated: `Tudo certo! ${this.member.NewSuiUser.name}  já criou uma conta!`,
        invited: `O convite foi enviado, mas ainda estamos aguardando que ${this.member.NewSuiUser.name} valide sua conta.`,
        new: `O convite foi enviado, mas ainda estamos aguardando que ${this.member.NewSuiUser.name} valide sua conta.`,
        unsaved: "Falta convidar uma pessoa para ocupar esta vaga. "
      };
      if (this.subsModel == 'onhb' || (this.index > 1 && this.modality == 'pre_zapzap')) {
        return translation[this.member.NewSuiUser.user_status];
      }
      else  {
        if (typeof (this.member.NewSuiUser.auxId) == 'undefined') {
          if (this.index == 1) {
            return `Falta você preencher seus dados adicionais!`;
          } else {
            return `Se quiser adicionar mais alguém preencha os dados desta pessoa.`;
          }
        } else {
          if (this.index == 1) {
            return `Tudo certo! Você já preencheu seus dados adicionais!`;
          } else {
            return `Tudo certo! ${this.member.NewSuiUser.name} já está registrado prá participar!`;
          }
        }
      }
    },
    printRole: function() {
      let translation = {
        orientador: "Professor(a) responsável",
        membro: "Estudante"
      };

      if (this.subsModel != 'onhb') {
        translation.membro = "Participante" + this.index;
      }

      let s = "";
      let nMember = this.index - 1;
      if (this.subsModel != 'onhb') {
        nMember = this.index;
      }
      if (this.role == "membro") {
        s = `\xa0#${nMember}\xa0\xa0`;
      }
      return translation[this.role];
    },
    statesList: function() {
      return states;
    },
    countriesList: function() {
      let i = 0;
      let countriesList = [];

      for (i = 0; i < countries.length; i++) {
        countriesList.push({
          'id' : "zzz - " + countries[i].name, //DONT REMOVE ZZZ Z is important
          'name': countries[i].name
        });
      }

      return countriesList;
    },
    citiesList: function() {
      let i;
      let citiesList = {};

      for (i = 0; i < states.length; i++) {
        citiesList[states[i].id] = [];
      }

      for (i = 0; i < cities.length; i++) {
        citiesList[cities[i].state].push({
          "name": cities[i].name
        });
      }

      return citiesList;
    },
    isCountry: function() {
      if (typeof this.member.SuiUserEdit.state != 'string') {
        return false;
      }
      if (this.member.SuiUserEdit.state.length == 0) {
        return false;
      }
      if (this.member.SuiUserEdit.state[0] != 'z') {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions(["inviteMember", "removeMember", "editMemberInfo"]),
    changeFieldData: function(field, value) {
      store.commit("CHANGE_MEMBER_FORM", {
        sui_user_id: this.member.NewSuiUser.id,
        property: field,
        value: value
      });
    },
    openEditForm: function() {
      store.commit("START_MEMBER_EDIT", this.member.NewSuiUser.id);
    },
    cancelEdit: function() {
      store.commit("CANCEL_MEMBER_EDIT", this.member.NewSuiUser.id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

.team-member {
  $default-bg: white;
  padding: pad(-1) pad(0) 0 pad(0);
  background: $default-bg;
  position: relative;

  &.confirmed {
    background: mix($default-bg, $status-ok, 80%);
  }
  &.invited {
    background: mix($default-bg, $status-waiting, 65%);
  }
  &.rejected_invitation,
  &.status-cancelled {
    background: mix($default-bg, $status-cancelled, 80%);
  }
  &.vacant {
    border-top: 1px solid grays(9);
    padding-top: pad(-3);
  }
  .actions {
    align-self: flex-end;
    display: flex;
    justify-content: space-between;
    > * {
      flex-grow: 1;
      flex-basis: 0;
      + * {
        margin-left: 1em;
      }
    }
  }

  display: grid;
  grid-column-gap: pad(0);
  grid-row-gap: pad(-1);
  grid-template-columns: 4fr 1fr;

  @include respond-below(sm) {
    grid-template-columns: 1fr;
  }

  & > * {
    align-self: center;
  }
}
.uninvited-member {
  display: grid;
  grid-gap: (2 * pad(-1)) / 3;
  grid-template-columns: 4fr 3fr 3fr 2fr 2fr;

  @include respond-between(xs, sm) {
    grid-template-columns: 1fr 1fr;
    padding-bottom: pad(-3);
    &.extended-fields {
      grid-template-columns: 1fr 1fr;
    }
  }
  @include respond-below(xs) {
    grid-template-columns: 1fr;
    padding-bottom: pad(-2);
    &.extended-fields {
      grid-template-columns: 1fr;
    }
  }

  &.extended-fields {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.person,
.grade {
  opacity: 0.9;
  @include fs(0);
}

.actions {
  display: grid;
  grid-gap: pad(-3);
}

.team-status {
  grid-column: 1 / -1;
  padding: pad(-2) + pad(-3) pad(0);
  width: calc(100% + #{2 * pad(0)});
  position: relative;
  left: -1 * pad(0);

  p {
    @include faux-caps;
    @include fs(-2);
    @extend .mono;
    opacity: 0.9;
  }

  @at-root .confirmed & {
    background: transparentize($status-ok, 0.75);
  }
  @at-root .invited & {
    background: transparentize($status-waiting, 0.75);
  }
  @at-root .rejected_invitation & {
    background: transparentize($status-cancelled, 0.85);
  }
  @at-root .status_cancelled & {
    background: transparentize($status-cancelled, 0.85);
  }
  @at-root .vacant & {
    background: grays(9.5);
  }
}

.warnings {
  grid-column: 1 / -1;
  padding: pad(-2) + pad(-3) pad(0);
  width: calc(100% + #{2 * pad(0)});
  position: relative;
  left: -1 * pad(0);
}

.fa {
  opacity: 0.5;
  width: pad(-1) + pad(-2);
  display: inline-block;
  @include fs(-2);
}
</style>
